import { useGetResources } from '@/queries/resources.queries';

interface ResourcesProps {
  as?: 'aside' | 'div';
  width?: 'full' | string;
  className?: string;
}

export default function Resources({ as = 'div', width, className, ...props }: ResourcesProps) {
  const route = window.location.pathname;
  const { data: resourcesData } = useGetResources(encodeURIComponent(route));
  const resources = resourcesData ?? [];

  if (!resources || !resources.length) return null;

  const Component = as;

  return (
    <div
      className={`dashboard-reset flex flex-col gap-4 h-fit p-5 lg:p-12 bg-white rounded-[10px] border border-solid border-[#d4c2b5] ${className || ''}`}
      {...props}
    >
      <h2 className="font-['Inter'] text-[25px] font-normal leading-[1.3] text-[#183344]">
        Additional Resources
      </h2>
      <div className="flex flex-col gap-[15px]">
        {resources.map((item) => (
          <div key={item.title} className="dashboard-reset">
            <a
              href={item.url}
              target="_blank"
              rel="noopener noreferrer"
              className="inline font-['Inter'] text-[16px] font-medium leading-[1.3] text-[#38749d] underline decoration-solid [text-decoration-skip-ink:none] [text-underline-position:from-font] hover:opacity-80 transition-opacity"
            >
              {item.title}
            </a>
          </div>
        ))}
      </div>
    </div>
  );
}
